import React from 'react';
import PropTypes from 'prop-types';

export default function StatsPanelItem({ value, title }) {
    return (
        <div className="stats-panel__item">
            <div className="stats-panel__item__value">
                {value}
            </div>
            <div className="stats-panel__item__title">
                {title}
            </div>
        </div>
    );
}

StatsPanelItem.propTypes = {
    value: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/stats-panel-item.jsx